import { errorActionTypes } from '@constants/actionTypes/commonActionTypes';

export const INITIAL_STATE = {
    errorStatus: false,
    errorMessage: null,
    errorType: null
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case errorActionTypes.SET_ERROR:

            if(
                Array.isArray(action.errorData) ||
                !(action.errorData instanceof Object) ||
                action.errorData === null ||
                typeof action.errorData === 'function'
            ) {
                throw new Error('Invalid value (not an object) has been passed in errorReducer');
            }

            return {
                errorStatus: true,
                ...action.errorData
            };
        case errorActionTypes.REMOVE_ERROR:
            return INITIAL_STATE;
        case errorActionTypes.CLEAR_COMMON_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
